import LoadingArovyLogo from 'images/integration-logos/ArovyLogo-Blue-Loading-HighlightSweep.svg';
import React from 'react';

export const LoadingArovy: React.FC = () =>
	<div>
		<img
			alt=''
			aria-hidden='true'
			className='arovy-logo'
			src={ LoadingArovyLogo } />
	</div>;
